export default __webpack_public_path__ + "static/media/iconPerfil.1c0521c6.svg";